import { toast } from "sonner";
import { Sprout } from "lucide-react";
import { http, formatApiError } from "@/lib/api";
import { Checkbox } from "@/components/ui/checkbox";

export const Milestones = ({ babyId, name, items, label, onChange }) => {
  const flip = async (m) => {
    try { await http.put(`/babies/${babyId}/milestones/${m.id}`, { done: !m.done_on }); if (!m.done_on) toast.success(`Yay, ${name}!`); onChange(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <section className="rounded-3xl bg-white border border-[#E6DEC3] p-6" data-testid="baby-milestones">
      <h3 className="font-display text-2xl text-[#2C4A3E] flex items-center gap-2"><Sprout className="w-5 h-5 text-[#6B9080]" />Milestones · {label}</h3>
      <p className="text-xs text-stone-500 mt-1">Every child grows at their own pace. Ask your pediatrician if you have questions.</p>
      <ul className="mt-4 space-y-2">
        {items.map((m) => (
          <li key={m.id}>
            <label className="flex items-center gap-3 rounded-xl px-3 py-2.5 hover:bg-[#F7F3EB] cursor-pointer transition-colors" data-testid={`baby-milestone-${m.id}`}>
              <Checkbox checked={!!m.done_on} onCheckedChange={() => flip(m)} data-testid={`baby-milestone-check-${m.id}`} />
              <span className={`flex-1 text-sm ${m.done_on ? "text-[#2E7D4F]" : "text-stone-700"}`}>{m.label}</span>
              {m.done_on && <span className="text-[11px] text-stone-500">{new Date(`${m.done_on}T12:00`).toLocaleDateString([], { month: "short", day: "numeric" })}</span>}
            </label>
          </li>))}
      </ul>
    </section>
  );
};
